import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'AppController',
	loadComponent: () =>
		process.env.PACKAGE_NAME === 'thunderbolt-ds'
			? import('./AppControllerPreviewExtension.js' /* webpackChunkName: "AppControllerPreviewExtension" */)
			: import('./AppController.js' /* webpackChunkName: "AppController" */),
}

export default entry
